module.exports = __webpack_public_path__ + "assets/img/noData.390e2a43.png";